import { Languages } from '@core';
import { TranslateService } from '@ngx-translate/core';
import { AppInjector } from '@app/services/app-injector.service';
import { UserService } from '@app/core/services/user/user.service';
import { User } from '@app/core/services/user/user.model';
import { NgxZendeskWebwidgetConfig } from '@nitsanzo/ngx-zendesk-webwidget';

export class ZendeskConfig extends NgxZendeskWebwidgetConfig {
	private translateService: TranslateService = AppInjector.injector.get(TranslateService);
	private userService: UserService = AppInjector.injector.get(UserService);
	private user: User = this.userService.getActiveUser();

	accountUrl = 'law-yal.zendesk.com';
	callback(zE) {
		const WEB_WIDGET: string = 'webWidget';
		zE(WEB_WIDGET, 'hide');
		zE(WEB_WIDGET, 'identify', {
			name: this.user.name,
			email: this.user.email
		});
		zE(WEB_WIDGET, 'prefill', {
			email: {
				value: this.user.email,
				readOnly: true
			}
		});
		zE(`${WEB_WIDGET}:on`, 'close', () => {
			zE(WEB_WIDGET, 'hide');
		});
		zE(`${WEB_WIDGET}:on`, 'open', () => {
			zE(WEB_WIDGET, 'show');
		});
		zE(WEB_WIDGET, 'setLocale', this.translateService.currentLang);
		zE(WEB_WIDGET, 'updateSettings', {
			webWidget: {
				position: {
					horizontal: this.translateService.currentLang === Languages.EN ? 'left' : 'right',
					vertical: 'bottom'
				}
			}
		});
	}

	constructor() {
		super();
	}
}
